import { render, staticRenderFns } from "./anquanfuwu.vue?vue&type=template&id=42252ab0&scoped=true&"
import script from "./anquanfuwu.vue?vue&type=script&lang=js&"
export * from "./anquanfuwu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42252ab0",
  null
  
)

component.options.__file = "anquanfuwu.vue"
export default component.exports